module.exports = __webpack_public_path__ + "img/2af86c9.png";